import { Anchor, Container, Stack, Text, Title } from '@mantine/core'
import type { ReactNode } from 'react'

import { useDocumentTitle } from '../../components/PageHeader'
import { StatusBanner } from '../../components/StatusBanner'

const LAST_UPDATED = 'Last updated: 25 October 2026'

/**
 * The shared frame for the public legal pages (`/privacy`, `/terms`, `/cookies`, `/delete-account`): these sit
 * outside the signed-in app shell, so no sign-in is needed to read them (main.tsx renders them before the auth
 * gate). A "Draft — under review" banner stays until the owner removes it.
 */
export function LegalPage(props: { title: string; children: ReactNode }) {
  useDocumentTitle(props.title)
  return (
    <Container size="sm" py="xl">
      <Stack gap="lg">
        <Stack gap={4}>
          <Anchor href="/dashboard" fw={600} fz={20} c="var(--mantine-primary-color-filled)" td="none" style={{ letterSpacing: '0.02em' }}>
            Macrotide
          </Anchor>
          <Title order={1}>{props.title}</Title>
          <Text size="sm" c="dimmed">
            {LAST_UPDATED}
          </Text>
        </Stack>
        <StatusBanner tone="warning">Draft — under review.</StatusBanner>
        {props.children}
      </Stack>
    </Container>
  )
}
